import React from 'react';
import { Avatar, type SxProps, type Theme } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useAuthenticatedFilePreview } from '../../hooks/useAuthenticatedFilePreview';

interface MitarbeiterAvatarProps {
  fileId?: number | null;
  name: string;
  size?: number;
  sx?: SxProps<Theme>;
}

const initialsOf = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
};

/** Rundes Profilbild. Ohne Datei oder waehrend des Ladens stehen die Initialen. */
export const MitarbeiterAvatar: React.FC<MitarbeiterAvatarProps> = ({ fileId, name, size = 36, sx }) => {
  const url = useAuthenticatedFilePreview(fileId ?? null);
  const initials = initialsOf(name);

  return (
    <Avatar
      src={fileId ? url : undefined}
      alt=""
      sx={[
        {
          width: size,
          height: size,
          fontSize: Math.max(11, Math.round(size * 0.38)),
          fontWeight: 700,
          flexShrink: 0,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {initials || <PersonOutlineIcon fontSize="small" />}
    </Avatar>
  );
};
